export const nbItemsPerRow: Dic<number> = {
  sm: 1,
  md: 2,
  lg: 3,
  xl: 4,
};
